export default "__VITE_ASSET__Bv$ceuIt__"